import React, { useContext, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  FormControl,
  Icon,
  Typography,
} from "@mui/material";
import newPasswordImg from "../../../assest/newPassword.svg";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialInput from "../../../components/MaterialInput";
import MaterialBox from "../../../components/MaterialBox";
import MaterialButton from "../../../components/MaterialButton";
import colors from "../../../assest/theme/base/colors";
import { useNavigate } from "react-router-dom";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import logo from "../../../assest/images/logo.jpg";
import { UserContext } from "../../usercontext/usercontext";
import { postItem } from "../../../BaseUrl";
import { PasswordReset } from "../Mutation";
import MessagePopup from "../../Utils/MessagePopup";

export default function ForgetPassword() {
  const navigate = useNavigate();
  const { email } = useContext(UserContext);
  const [passwordData, setPasswordData] = useState({
    password: "",
    confirmPassword: "",
    passwordStatus: "unchecked",
    confirmPasswordStatus: "unchecked",
  });
  const [popup, setPopup] = useState({
    open: false,
    message: "",
    severity: "success", // 'success' or 'error'
  });

  const [touchedFields, setTouchedFields] = useState({
    password: false,
    confirmPassword: false,
  });

  const [viewPassword, setViewPassword] = useState(false);
  const [viewConfirmPassword, setViewConfirmPassword] = useState(false);

  const handlePasswordVisibility = () => {
    setViewPassword(!viewPassword);
  };

  const handleConfirmPasswordVisibility = () => {
    setViewConfirmPassword(!viewConfirmPassword);
  };

  const handleChange = (event) => {
    const lowerCaseRegex = new RegExp("^(?=.*[a-z])");
    const upperCaseRegex = new RegExp("^(?=.*[A-Z])");
    const numberRegex = new RegExp("^(?=.*[0-9])");
    const specialCharacterRegex = new RegExp("^(?=.*[@$!%*?&])");
    const lengthRegex = new RegExp("([a-zA-Z0-9@$!%*?&]{8,})$");

    let updatedData = { ...passwordData };

    if (event.target.name === "password") {
      const value = event.target.value;
      updatedData.password = value;

      if (
        lowerCaseRegex.test(value) &&
        upperCaseRegex.test(value) &&
        numberRegex.test(value) &&
        specialCharacterRegex.test(value) &&
        lengthRegex.test(value)
      ) {
        updatedData.passwordStatus = "success";
      } else {
        updatedData.passwordStatus = "error";
      }
    }

    if (event.target.name === "confirmPassword") {
      updatedData.confirmPassword = event.target.value;

      if (
        event.target.value === updatedData.password &&
        event.target.value !== ""
      ) {
        updatedData.confirmPasswordStatus = "success";
      } else {
        updatedData.confirmPasswordStatus = "error";
      }
    }

    setPasswordData(updatedData);
  };

  const handleBlur = (field) => {
    setTouchedFields({ ...touchedFields, [field]: true });
  };

  const resetPassword = async () => {
    const { password } = passwordData;
    const variables = {
      email: email,
      new_password: password,
    };

    try {
      const response = await postItem(PasswordReset, variables);
      if (response?.resetPassword?.success === true) {
        setPopup({
          open: true,
          message: "Password Reset Successfully",
          severity: "success",
        });
        setTimeout(() => {
          navigate("/reset-successful");
        }, 1000);
      } else {
        setPopup({
          open: true,
          message: response?.resetPassword?.message,
          severity: "error",
        });
      }
    } catch (error) {
      console.error(error);
      setPopup({
        open: true,
        message: error,
        severity: "error",
      });
    } finally {
    }
  };

  return (
    <Box>
      <MessagePopup
        message={popup.message}
        severity={popup.severity}
        open={popup.open}
        setPopup={setPopup}
      />
      <Box sx={{ p: 4 }}>
        <img
          src={logo}
          alt="log img"
          style={{ height: "60px", width: "140px" }}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "70vh",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-evenly",
            gap: 2,
            width: "100%",
          }}
        >
          {/* Illustration Section */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <img src={newPasswordImg} alt="Forget Password" />
          </Box>

          {/* Form Section */}
          <Card
            sx={{
              flex: 1,
              maxWidth: 400,
              padding: 4,
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            }}
          >
            <CardContent>
              <MaterialTypography variant="h6" fontWeight="bold" gutterBottom>
                Forgot Password
              </MaterialTypography>
              <MaterialTypography
                sx={{ marginBottom: 2, color: "#989898", fontSize: "14px" }}
              >
                Please create a new password and confirm it below.
              </MaterialTypography>

              {/* Password Field */}
              <FormControl fullWidth>
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                  sx={{ color: "black" }}
                >
                  Password:
                </MaterialTypography>
                <MaterialInput
                  fullWidth
                  placeholder="Password"
                  name="password"
                  type={viewPassword ? "text" : "password"}
                  variant="standard"
                  value={passwordData.password}
                  onChange={handleChange}
                  onBlur={() => handleBlur("password")}
                  error={
                    touchedFields.password &&
                    passwordData.passwordStatus === "error"
                  }
                  success={
                    passwordData.passwordStatus === "success" ? true : false
                  }
                  icon={{
                    direction: "right",
                    component: (
                      <Icon
                        color="action"
                        fontSize="small"
                        onClick={handlePasswordVisibility}
                        style={{ cursor: "pointer" }}
                      >
                        {viewPassword ? (
                          <VisibilityOffIcon />
                        ) : (
                          <VisibilityIcon />
                        )}
                      </Icon>
                    ),
                  }}
                />
                {touchedFields.password &&
                  passwordData.passwordStatus === "error" && (
                    <Typography variant="caption" color="error">
                      Password must be at least 8 characters long, contain one
                      uppercase, one lowercase, one number, and one special
                      character.
                    </Typography>
                  )}
              </FormControl>

              {/* Confirm Password Field */}
              <FormControl fullWidth sx={{ marginTop: 2 }}>
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                  sx={{ color: "black" }}
                >
                  Confirm Password:
                </MaterialTypography>
                <MaterialInput
                  fullWidth
                  placeholder="Confirm Password"
                  name="confirmPassword"
                  type={viewConfirmPassword ? "text" : "password"}
                  variant="standard"
                  value={passwordData.confirmPassword}
                  onChange={handleChange}
                  onBlur={() => handleBlur("confirmPassword")}
                  error={
                    touchedFields.confirmPassword &&
                    passwordData.confirmPasswordStatus === "error"
                  }
                  success={
                    passwordData.confirmPasswordStatus === "success"
                      ? true
                      : false
                  }
                  icon={{
                    direction: "right",
                    component: (
                      <Icon
                        color="action"
                        fontSize="small"
                        onClick={handleConfirmPasswordVisibility}
                        style={{ cursor: "pointer" }}
                      >
                        {viewConfirmPassword ? (
                          <VisibilityOffIcon />
                        ) : (
                          <VisibilityIcon />
                        )}
                      </Icon>
                    ),
                  }}
                />
                {touchedFields.confirmPassword &&
                  passwordData.confirmPasswordStatus === "error" && (
                    <Typography variant="caption" color="error">
                      Passwords do not match.
                    </Typography>
                  )}
              </FormControl>

              {/* Submit Button */}
              <MaterialBox
                sx={{ display: "flex", justifyContent: "center" }}
                my={2}
              >
                <MaterialButton
                  variant="contained"
                  onClick={resetPassword}
                  disabled={
                    passwordData.passwordStatus !== "success" ||
                    passwordData.confirmPasswordStatus !== "success"
                  }
                  sx={{
                    background: colors.buttonColor,
                    color: "#fff",
                    textTransform: "capitalize",
                  }}
                >
                  Reset Password
                </MaterialButton>
              </MaterialBox>
            </CardContent>
          </Card>
        </Box>
      </Box>
    </Box>
  );
}
